import axiosInstance from './axiosInstance';

const DownloadableDocumentService = {
  getDocuments: () => axiosInstance.get('/api/downloadable-documents/'),
  
  getDocument: (id) => axiosInstance.get(`/api/downloadable-documents/${id}/`),
  
  createDocument: (data, file) => {
    const formData = new FormData();
    formData.append('title', data.title || '');
    formData.append('description', data.description || '');
    formData.append('category', data.category || '');
    if (data.language) formData.append('language', data.language);

    if (file) {
      formData.append('pdf_file', file);
    }

    if (process.env.NODE_ENV === 'development') {
      for (const pair of formData.entries()) {
        // eslint-disable-next-line no-console
        console.debug('[DownloadableDocumentService] FormData', pair[0], pair[1]);
      }
    }

    return axiosInstance.post('/api/downloadable-documents/', formData, {
      timeout: 180000,
    });
  },

  updateDocument: (id, data, file) => {
    if (file) {
      const formData = new FormData();
      formData.append('title', data.title || '');
      formData.append('description', data.description || '');
      formData.append('category', data.category || '');
      if (data.language) formData.append('language', data.language);
      formData.append('pdf_file', file);

      if (process.env.NODE_ENV === 'development') {
        for (const pair of formData.entries()) {
          // eslint-disable-next-line no-console
          console.debug('[DownloadableDocumentService] FormData', pair[0], pair[1]);
        }
      }

      return axiosInstance.patch(`/api/downloadable-documents/${id}/`, formData, {
        timeout: 180000,
      });
    }

    const payload = {
      title: data.title || '',
      description: data.description || '',
      category: data.category || '',
    };
    if (data.language) payload.language = data.language;

    payload.keep_file = true;
    if (process.env.NODE_ENV === 'development') {
      // eslint-disable-next-line no-console
      console.debug('[DownloadableDocumentService] PATCH payload', payload);
    }

    return axiosInstance.patch(`/api/downloadable-documents/${id}/`, payload);
  },

  deleteDocument: (id) => axiosInstance.delete(`/api/downloadable-documents/${id}/`),

  downloadDocument: (id) => {
    return axiosInstance.get(`/api/downloadable-documents/${id}/download/`, {
      responseType: 'blob',
    });
  },

  // Get document info for a category
  getDocInfo: (category) => {
    return axiosInstance.get(`/api/downloadable-documents/by-category/${category}/`);
  },

  // Get download URL for a category
  downloadByCategory: (category) => {
    const baseURL = process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000/';
    return `${baseURL}api/downloadable-documents/by-category/${category}/download/`;
  },
};

export default DownloadableDocumentService;
